const getItemHeader = index =>
  `${index > 0 ? '\n\n' : ''}${I18n.t('components.ibe.search_results.item_header', {
    itemNo: index + 1,
  })}\n`;

export default getItemHeader;
